import { render, staticRenderFns } from "./202310.vue?vue&type=template&id=31286204&scoped=true&"
import script from "./202310.vue?vue&type=script&lang=js&"
export * from "./202310.vue?vue&type=script&lang=js&"
import style0 from "./202310.vue?vue&type=style&index=0&id=31286204&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31286204",
  null
  
)

export default component.exports